export function listFilter(listItem) {
  if (!listItem.scheduled) return listItem;
  else {
    if (dateInBetween(listItem)) return listItem;
  }
  function dateInBetween(listItem) {
    return (
      new Date() >= new Date(listItem.startDate) &&
      new Date() <= new Date(listItem.endDate)
    );
  }
}
